import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { Table } from 'semantic-ui-react';
import isEqual from 'lodash.isequal';
import moment from 'moment';

// Selectors
import {
    selectGroupBy,
    makeSelectGroupedDataValueIds
    // @ts-ignore
} from 'services/timesheetTimesheetEntriesForm/selectors';

// Components
import RoleGate from '../../../../../../../../../../components/RoleGate';
import {
    ADMIN,
    MANAGER,
    ASSISTANT_MANAGER
} from '../../../../../../../../../../components/RoleGate/constants';
import SelectedTableCellRowCheckbox from '../../../../../../../../components/SelectedTableCellRowCheckbox';
import TimesheetTimesheetEntriesTableRow from '../../../TimesheetTimesheetEntriesTableRow';
// @ts-ignore
import HourlyRateEntryExistsGate from '../../../HourlyRateEntryExistsGate';
// @ts-ignore
import PieceRateEntryExistsGate from '../../../PieceRateEntryExistsGate';
import TimesheetTimesheetEntriesTableGroupingAverageEffectiveRate from './components/TimesheetTimesheetEntriesTableGroupingAverageEffectiveRate';
// @ts-ignore
import TimesheetTimesheetEntriesTableGroupingTotal from './components/TimesheetTimesheetEntriesTableGroupingTotal';

interface Props {
    groupBy?: string;
    groupingId: string;
    ids?: any;
}

export class TimesheetTimesheetEntriesTableGrouping extends React.Component<Props> {
    shouldComponentUpdate(nextProps: Props): boolean {
        const { ids } = this.props;
        return !isEqual(ids, nextProps.ids);
    }

    render(): React.ReactElement | null {
        const { groupBy, groupingId, ids } = this.props;
        if (!ids || !ids.length) return null;

        return (
            <React.Fragment>
                {groupBy !== 'timesheetId' && (
                    <Table.Row colSpan="19">
                        <RoleGate
                            requiredRoles={[ADMIN, MANAGER, ASSISTANT_MANAGER]}
                        >
                            <Table.Cell
                                style={{
                                    lineHeight: 0
                                }}
                            >
                                <SelectedTableCellRowCheckbox rowId={ids} />
                            </Table.Cell>
                        </RoleGate>
                        <Table.Cell colSpan="18">
                            <b>
                                {groupBy === 'date'
                                    ? moment(groupingId).format('DD/MM/YYYY')
                                    : groupingId}
                            </b>
                        </Table.Cell>
                    </Table.Row>
                )}
                {ids.map((id: any) => (
                    <TimesheetTimesheetEntriesTableRow key={id} rowId={id} />
                ))}
                <Table.Row>
                    <RoleGate
                        requiredRoles={[ADMIN, MANAGER, ASSISTANT_MANAGER]}
                        fallback={<Table.Cell colSpan="7" />}
                    >
                        <Table.Cell colSpan="9" />
                    </RoleGate>
                    <HourlyRateEntryExistsGate>
                        <Table.Cell>
                            <b>
                                <TimesheetTimesheetEntriesTableGroupingTotal
                                    groupingId={groupingId}
                                    hours
                                    fieldName="totalPaidHours"
                                />
                            </b>
                        </Table.Cell>
                    </HourlyRateEntryExistsGate>
                    <Table.Cell>
                        <b>
                            <TimesheetTimesheetEntriesTableGroupingTotal
                                groupingId={groupingId}
                                fieldName="units"
                            />
                        </b>
                    </Table.Cell>
                    <PieceRateEntryExistsGate>
                        <Table.Cell colSpan="2" />
                        <Table.Cell>
                            <b>
                                <TimesheetTimesheetEntriesTableGroupingTotal
                                    groupingId={groupingId}
                                    fieldName="totalPieceRateHours"
                                    hours
                                />
                            </b>
                        </Table.Cell>
                        <Table.Cell>
                            <b>
                                <TimesheetTimesheetEntriesTableGroupingTotal
                                    groupingId={groupingId}
                                    fieldName="earnings"
                                    dollars
                                />
                            </b>
                        </Table.Cell>
                        <Table.Cell>
                            <b>
                                <TimesheetTimesheetEntriesTableGroupingAverageEffectiveRate
                                    groupingId={groupingId}
                                    isPieceRate
                                    dollars
                                />
                            </b>
                        </Table.Cell>
                        <Table.Cell>
                            <b>
                                <TimesheetTimesheetEntriesTableGroupingTotal
                                    groupingId={groupingId}
                                    fieldName="paidBreakDollars"
                                    dollars
                                />
                            </b>
                        </Table.Cell>
                    </PieceRateEntryExistsGate>
                    <Table.Cell />
                </Table.Row>
            </React.Fragment>
        );
    }
}

const mapStateToProps = createStructuredSelector<any, any, any>({
    groupBy: selectGroupBy,
    ids: makeSelectGroupedDataValueIds()
});

export default connect(mapStateToProps)(TimesheetTimesheetEntriesTableGrouping);
